// The Activity list's one presentation rule that is about transactions rather
// than about numbers. Amount and date formatting live in `@/shared/utils/format`
// with every other formatter in the app — this module briefly re-exported them
// so no call site had to move, which meant `formatCredits` had two import paths
// and two test files, and two of the three call sites reaching for the wallet's
// copy were in the *generation* slice.

import type { WalletTransaction } from '@/shared/types';

// Human label for an activity row. Adjustments (ops refunds) carry a descriptive
// note; fall back to "Refund" when absent.
export function transactionLabel(tx: Pick<WalletTransaction, 'kind' | 'note'>): string {
  switch (tx.kind) {
    case 'topup':
      return 'Top-up';
    case 'charge':
      return 'Video generation';
    case 'adjustment':
      return tx.note?.trim() || 'Refund';
    default:
      return 'Transaction';
  }
}
